module.exports = __webpack_public_path__ + "images/emoji/womans_hat.e8ca02bf6ce3415c3682.png";